var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "identity-to-validate-modal",
      attrs: {
        id: "identity-to-validate-modal",
        "header-class": "identity-to-validate-header",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.handleSubmit },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass: "identity-to-validate-header-content step4 w-100"
                },
                [
                  _c(
                    "div",
                    { staticClass: "identity-to-validate-container h-100" },
                    [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "page-title ml-4 identity-to-validate-title"
                        },
                        [_vm._v(_vm._s(_vm.$t("modal.identity.refused.title")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass:
                            "page-title mt-4 ml-4 identity-to-validate-subtitle"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("modal.identity.refused.subtitle"))
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass:
                      "identity-to-validate-step-img margin-bottom-15",
                    attrs: {
                      src: require("@/assets/images/b122/img-watcher-right.png")
                    }
                  })
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Validate")))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-1 align-self-center"
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          [
            _c("p", {
              staticClass: "identity-to-validate-text mt-2",
              domProps: {
                innerHTML: _vm._s(_vm.$t("onboarding.need.identity"))
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "identity-to-validate-text mt-2",
              domProps: {
                innerHTML: _vm._s(_vm.$t("onboarding.identity.wont.conserve"))
              }
            }),
            _vm._v(" "),
            _c("b-form", [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          label: _vm.$t("Recto"),
                          "label-for": "recto-input",
                          "invalid-feedback": _vm.identity.recto.invalidFeedback
                        }
                      },
                      [
                        _c("b-form-file", {
                          attrs: {
                            id: "recto-input",
                            "browse-text": _vm.$t("Select"),
                            "drop-placeholder": _vm.$t("drop-placeholder"),
                            placeholder: _vm.identity.recto.value
                              ? _vm.identity.recto.value.name
                              : "",
                            state: _vm.identity.recto.state,
                            required: "",
                            accept: ".png, .jpeg, .jpg, .pdf"
                          },
                          on: {
                            change: function($event) {
                              return _vm.removeInvalidFeedback("recto")
                            }
                          },
                          model: {
                            value: _vm.identity.recto.value,
                            callback: function($$v) {
                              _vm.$set(_vm.identity.recto, "value", $$v)
                            },
                            expression: "identity.recto.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          label: _vm.$t("Verso"),
                          "label-for": "verso-input",
                          "invalid-feedback": _vm.identity.verso.invalidFeedback
                        }
                      },
                      [
                        _c("b-form-file", {
                          staticClass: "custom-file",
                          attrs: {
                            id: "verso-input",
                            "browse-text": _vm.$t("Select"),
                            "drop-placeholder": _vm.$t("drop-placeholder"),
                            placeholder: _vm.identity.verso.value
                              ? _vm.identity.verso.value.name
                              : "",
                            state: _vm.identity.verso.state,
                            required: "",
                            accept: ".png, .jpeg, .jpg, .pdf"
                          },
                          on: {
                            change: function($event) {
                              return _vm.removeInvalidFeedback("verso")
                            }
                          },
                          model: {
                            value: _vm.identity.verso.value,
                            callback: function($$v) {
                              _vm.$set(_vm.identity.verso, "value", $$v)
                            },
                            expression: "identity.verso.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c970d94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c970d94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/IdentityToValidateModal.vue
// module id = cHJm
// module chunks = 0